<template>
    <div class="table-responsive app-table p-1">
        <table class="table table-striped b-t table-color" id="my-table">
            <thead>
                <tr>
                    <th></th>
                    <th>Fecha de creación</th>
                    <th>Tracking</th>
                    <th>HAWB</th>
                    <th>Contenido</th>
                    <th>Estado</th>
                    <th>Peso lbs</th>
                    <th>Observación</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="paquete in paquetes" :key="paquete.id">
                    <td>
                        <b-button variant="outline-dark" @click="onRastrear(paquete)">
                            <b-icon icon="truck" aria-hidden="true"></b-icon> Rastrear
                        </b-button>
                    </td>
                    <td class="ng-binding">{{paquete.created_at}}</td>
                    <td class="ng-binding">{{paquete.tracking_tienda_casillero}}</td>
                    <td class="ng-binding">{{paquete.hawb}}</td>
                    <td class="ng-binding">{{paquete.contenido}}</td>
                    <td class="ng-binding">{{paquete.estados_de_guia_descripcion}}</td>
                    <td class="ng-binding">{{paquete.peso}}</td>
                    <td class="ng-binding">{{paquete.observacion_tracking}}</td>
                </tr>
                <tr v-show="paquetes.length == 0 && !cargando">
                    <td colspan="8" class="ng-binding text-center">No hay registros</td>
                </tr>
            </tbody>
        </table>
        <div v-show="cargando" class="text-center app-bkg-color-f5 app-no-data-table b-t">
            <Cargando/>
        </div>
    </div>
</template>

<script>
import Cargando from '../layouts/Cargando.vue';

export default {
    name: "HistorialTable",
    components: {
        Cargando
    },
    props: {
        paquetes: {
            type: [Array, String],
            required: true
        },
        cargando: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onRastrear(paquete) {
            this.$emit('rastrear', paquete);
        }
    }
}
</script>

<style scoped>
.table-color {
    color: black !important;
    background: aliceblue !important;
}
.btn-outline-dark:hover{
    background: var(--primary-color) !important;
    border-color: #343a40 !important;
    color: #fff !important;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: none !important;
}
</style>
